export default "__VITE_ASSET__D$x2ogCq__"